import { breakpoints } from './breakpoints';
import type { MediaQueries } from './types';

const { lg, md, sm, xl, xs } = breakpoints;

const BREAKPOINTS = { xs, sm, md, lg, xl };
export type Breakpoints = keyof typeof BREAKPOINTS;

const mediaUp = (breakpoint: Breakpoints, mediaSuffix?: boolean) =>
  `${mediaSuffix ? '@media only screen and ' : ''}(min-width: ${
    BREAKPOINTS[breakpoint]
  })`;

const mediaDown = (breakpoint: Breakpoints, mediaSuffix?: boolean) =>
  `${mediaSuffix ? '@media only screen and ' : ''}(max-width: calc(${
    BREAKPOINTS[breakpoint]
  } - 1px))`;

const mediaOnly = (breakpoint: Breakpoints) => {
  const breakpointKeys = Object.keys(BREAKPOINTS) as Breakpoints[];
  const nextBreakpointIndex = breakpointKeys.indexOf(breakpoint) + 1;
  const prevBreakpointIndex = breakpointKeys.indexOf(breakpoint) - 1;
  const nextBreakpoint =
    nextBreakpointIndex < breakpointKeys.length
      ? breakpointKeys[nextBreakpointIndex]
      : null;

  if (!nextBreakpoint) {
    return mediaUp(breakpoint, true);
  }

  if (prevBreakpointIndex === -1) {
    return mediaDown(nextBreakpoint, true);
  }

  return `@media only screen and ${mediaUp(breakpoint)} and ${mediaDown(
    nextBreakpoint,
  )}`;
};

export const media: MediaQueries = Object.keys(BREAKPOINTS).reduce(
  (acc: MediaQueries, breakpoint) => {
    const label = breakpoint as Breakpoints;
    acc[label] = {
      down: mediaDown(label, true),
      only: mediaOnly(label),
      up: mediaUp(label, true),
    };
    return acc;
  },
  {} as MediaQueries,
);
